module.exports = __webpack_public_path__ + "media/src/application/media/favicon-8701e8a4010e0ddc24c6717a9dfd5c2d.ico";